import { useRef, useState } from 'react';
import axios from 'axios';
import { Plus, X } from 'lucide-react';
import { toast } from 'sonner';
import { resolveImgUrl } from '@/utils/imgUrl';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function MultiImageUpload({ value = [], onChange, maxPhotos = 3, label = 'Foto Produk' }) {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { toast.error('Maksimal 5MB per foto'); return; }
    if (value.length >= maxPhotos) { toast.error(`Maksimal ${maxPhotos} foto`); return; }

    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);
    try {
      const { data } = await axios.post(`${API}/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      onChange([...value, data.url]);
      toast.success('Foto diunggah');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Gagal mengunggah foto');
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  const remove = (idx) => onChange(value.filter((_, i) => i !== idx));

  return (
    <div>
      {label && (
        <label className="block text-xs font-semibold text-gray-600 mb-1.5">
          {label} <span className="text-gray-400 font-normal">(maks {maxPhotos})</span>
        </label>
      )}
      <div className="flex flex-wrap gap-2">
        {value.map((url, idx) => (
          <div
            key={idx}
            data-testid={`foto-thumb-${idx}`}
            className="relative w-16 h-16 rounded-xl overflow-hidden border border-gray-200 group flex-shrink-0"
          >
            <img src={resolveImgUrl(url)} alt="" className="w-full h-full object-cover" />
            <button
              type="button"
              onClick={() => remove(idx)}
              className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 active:opacity-100 transition-opacity flex items-center justify-center"
            >
              <X size={16} className="text-white" />
            </button>
          </div>
        ))}
        {value.length < maxPhotos && (
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            disabled={uploading}
            data-testid="foto-add-btn"
            className="w-16 h-16 rounded-xl border-2 border-dashed border-gray-300 hover:border-emerald-400 flex flex-col items-center justify-center transition-colors disabled:opacity-60 flex-shrink-0"
          >
            {uploading ? (
              <div className="w-4 h-4 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin" />
            ) : (
              <>
                <Plus size={18} className="text-gray-400" />
                <span className="text-[9px] text-gray-400 mt-0.5">Foto</span>
              </>
            )}
          </button>
        )}
      </div>
      <p className="text-[10px] text-gray-400 mt-1.5">JPG, PNG, WebP · Maks 5MB per foto</p>
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handleFile} />
    </div>
  );
}
